import gql from 'graphql-tag';

const contact = `
getContactById(contactId: $contactId) {
  address {
    adminArea
    city
    locality
    postalCode
    state
    street
    street2
  }
  cellPhoneNumber
  email
  id
  isPrimary
  maritalStatus
  name
  phoneNumber
  taxIdentifier
}
`;
const getContactAndOpportunityRoles = gql`
  query getContactAndOpportunityRoles($contactId: String!, $opportunityId: String!) {
    ${contact}
    opportunityContactRoles(opportunityId: $opportunityId) {
      contact {
        name
        taxIdentifier
      }
      contactId
      id
      isPrimary
      role
    }
  }
`;

export const getContactById = gql`
  query getContactById($contactId: String!) {
    ${contact}
   }
`;

export { getContactAndOpportunityRoles };
